const { addFilter } = wp.hooks;
const { createHigherOrderComponent } = wp.compose;

/**
 * Class Control
 */
export default class Control {
  /**
   * Constructor
   *
   * @param {string} block
   * @param {object} options
   */
  constructor(block, options = {}) {
    this.block = block;
    this.options = options;

    this.registerFilters();
  }

  /**
   * Check if current block should apply filter
   *
   * @param {string} blockname
   * @returns boolean
   */
  isAcceptedBlock(blockname) {
    // Array
    if (Array.isArray(this.block)) {
      return this.block.indexOf(blockname) !== -1;
    }

    // Any || block
    return this.block == '*' || this.block === blockname;
  }

  /**
   * Registers filters
   */
  registerFilters() {
    if (this.registerBlockType) {
      addFilter(
        'blocks.registerBlockType',
        'blockbuilder/filters',
        settings => {
          return this.isAcceptedBlock(settings.name)
            ? this.registerBlockType(settings)
            : settings;
        }
      );
    }

    if (this.BlockEdit) {
      addFilter(
        'editor.BlockEdit',
        'blockbuilder/filters',
        createHigherOrderComponent(Block => {
          return props => {
            return this.isAcceptedBlock(props.name) ? (
              this.BlockEdit(Block, props)
            ) : (
              <Block {...props} />
            );
          };
        })
      );
    }

    if (this.extraProps) {
      addFilter(
        'blocks.getSaveContent.extraProps',
        'blockbuilder/filters',
        (props, blockType, attributes) => {
          return this.isAcceptedBlock(blockType.name)
            ? this.extraProps(props, blockType, attributes)
            : props;
        }
      );
    }
  }
}
